module.exports = __webpack_public_path__ + "static/media/TO220.2a0532cb.glb";